export default "__VITE_ASSET__RBqenTAx__"